import { createTheme, ThemeOptions } from '@mui/material/styles';

const commonThemeOptions: ThemeOptions = {
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontSize: '2.5rem', fontWeight: 500 },
    h2: { fontSize: '2rem', fontWeight: 500 },
    h3: { fontSize: '1.75rem', fontWeight: 500 },
    h4: { fontSize: '1.5rem', fontWeight: 500 },
    h5: { fontSize: '1.25rem', fontWeight: 500 },
    h6: { fontSize: '0.875rem', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
          height: 40,
          minHeight: 40,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '64px',
          padding: '0px !important',
        },
        gutters: {
          padding: '0px !important',
        },
        regular: {
          minHeight: '64px',
        }
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: 40,
          minHeight: 40,
        },
        input: {
          padding: 4,
          height: 40,
          minHeight: 40,
          boxSizing: 'border-box',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          transform: 'translate(14px, 12px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
        },
        paginationToolbar: {
          minHeight: '32px !important',
          height: '32px !important',
          maxHeight: '32px !important',
          '& .MuiInputBase-root': {
            height: '32px !important',
            minHeight: '32px !important',
            maxHeight: '32px !important',
          },
          '& .MuiOutlinedInput-root': {
            height: '32px !important',
            minHeight: '32px !important',
            maxHeight: '32px !important',
          },
          '& .MuiSelect-root': {
            height: '32px !important',
            minHeight: '32px !important',
            maxHeight: '32px !important',
          },
          '& .MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root': {
            height: '32px !important',
            minHeight: '32px !important',
            maxHeight: '32px !important',
          },
          '& .MuiInputBase-root.MuiOutlinedInput-root.MuiSelect-root.MuiInputBase-sizeSmall': {
            height: '32px !important',
            minHeight: '32px !important',
            maxHeight: '32px !important',
          },
        },
      },
    },
  } as any,
  shape: {
    borderRadius: 4
  },
};

export const lightTheme = createTheme({
  ...commonThemeOptions,
  palette: {
    mode: 'light',
    primary: {
      main: '#086428',
      light: '#3a8656',
      dark: '#054419',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
  },
});

export const darkTheme = createTheme({
  ...commonThemeOptions,
  palette: {
    mode: 'dark',
    primary: {
      main: '#3a8656',
      light: '#6ab785',
      dark: '#054419',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ba68c8',
      light: '#ee98fb',
      dark: '#883997',
      contrastText: '#ffffff',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  components: {
    ...commonThemeOptions.components,
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
            borderColor: 'rgba(255, 255, 255, 0.12)',
          },
        },
      },
    },
  } as any,
});

export default lightTheme; 